module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-style/i1-7-9fe319150f5afedcfcf82117c5b72aac.svg";